module.exports = __webpack_public_path__ + "static/index/img/baikal-214.8088a2ce.jpg";